<a href="" [target]="link.target" [title]="link.tooltip" [style]="style" class="link-template" (click)="handleLinkClick($event, link.link)">{{link.text}} </a>
